import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ModelInfoType, ReduxState } from 'redux/types';

interface Params {
    modelName: string;
}

const useModelInfo = ({ modelName }: Params): ModelInfoType => {
    const modelsInfo = useSelector((state: ReduxState) => state.modelsInfo);

    const thisModelInfo = modelsInfo.find(model => model.name === modelName);

    return useMemo(() => {
        return thisModelInfo ?? {
            name: modelName,
            requiredAttributes: [],
            translatableAttributes: []
        };
    }, [modelName, thisModelInfo]);
};

export default useModelInfo;